import * as R from 'unitx/ramda';
import * as V from 'unitx/vector';
export function dragTrack(onDrag) {
  const mutableData = {
    position: null
  };

  const onDown = position => {
    mutableData.position = position;
  };

  const onMove = position => R.when(R.isNotNil, () => {
    const result = onDrag(V.subtract(mutableData.position)(position));
    mutableData.position = position;
    return R.pipe(R.tap(R.when(R.propEq('keepDragging', false), () => {
      mutableData.position = null;
    })), R.tap(R.when(R.has('position'), () => {
      // @ts-ignore
      mutableData.position = result.position;
    })))(result !== null && result !== void 0 ? result : {});
  })(mutableData.position);

  document.addEventListener('mouseup', () => {
    mutableData.position = null;
  });
  return {
    onDown,
    onMove
  };
}